export class Integrationsetting {
    hubSpotKey:string;
    filterfield1:string;
    filtervalue1:string;
    filterfield2:string;
    filtervalue2:string;
    filterfield3:string;
    filtervalue3:string;
    propertyfield1:string;
    propertyvalue1:string;
    propertyfield2:string;
    propertyvalue2:string;
    propertyfield3:string;
    propertyvalue3:string;
    emailsetting:string;
    smtp2goapikey:string;
    smtpserverurl:string;
    smtpusername:string;
    smtppassword:string;
    fromaddress:string;
}